import { getAltaDomain, validDevelopmentUrlRegEx } from 'utils/domains';
import { getWindowLocation } from 'utils/window';

export const getControlCenterOrigin = () => {
  const { origin } = getWindowLocation();

  // local development
  if (validDevelopmentUrlRegEx.test(origin)) {
    return origin;
  }

  // for deployed envs
  const domain = getAltaDomain();

  if (domain) {
    const controlCenterProductionDomains = [
      'alta.avigilon.com',
      'eu.alta.avigilon.com',
    ];

    if (controlCenterProductionDomains.includes(domain)) {
      return `https://access.${domain}`;
    }

    return `https://platinum.${domain}`;
  }
};
